import { render, staticRenderFns } from "./SpecialBuilds.vue?vue&type=template&id=0d484ca9"
import script from "./SpecialBuilds.vue?vue&type=script&lang=js"
export * from "./SpecialBuilds.vue?vue&type=script&lang=js"
import style0 from "./SpecialBuilds.vue?vue&type=style&index=0&id=0d484ca9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports